import React from "react";

interface CardBackdropProps {
  isVisible: boolean;
  onClick: () => void;
}

const CardBackdrop: React.FC<CardBackdropProps> = ({ isVisible, onClick }) => {
  if (!isVisible) return null;

  return (
    <div
      className="card-backdrop"
      onClick={onClick}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        zIndex: 100,
      }}
    />
  );
};

export default CardBackdrop;